<template>
    <div class="theme-container">
        <div class="theme-content">
            <div style="flex-grow:1">
                <div>
                    <span class="theme-label required-field">主题名称</span>
                    <a-input class="width-300" v-model="themeInfo.name" placeholder="请输入主题名称" />
                </div>
                <div class="theme-des">
                    <span class="theme-label required-field">主题说明</span>
                    <a-textarea v-model="themeInfo.description" placeholder="请输入主题说明，最多200字"
                        :auto-size="{ minRows: 5 }" :maxLength="200" style="resize: none" />
                </div>
                <div class="theme-background">
                    <span class="theme-label required-field">主题背景</span>
                    <a-upload :customRequest="event => customRequest(event)"
                        list-type="picture-card" :show-upload-list="false">
                        <img v-if="themeInfo.background_image_url" class="theme-background_image"
                            :src="themeInfo.background_image_url" />
                        <div v-else class="theme-background_image">
                            <svg-icon iconClass="plus"></svg-icon>
                        </div>
                    </a-upload>
                </div>
            </div>
        </div>
        <a-button class="submit-btn" @click="submitHandle">提交</a-button>
		<app-view-img :imageList.sync="imageList" :imageIndex.sync="imageIndex" />
    </div>
</template>
  
<script>
import AppViewImg from "@/components/AppViewImg";
import { uploadHandle } from "@/utils";
import ThemeService from "@/api/themeService";
import { mapGetters } from "vuex";

export default {
    name: "klassDetail",
    components: { AppViewImg },
    data() {
        return {
			imageList: [],
			imageIndex: 0,
            themeTypeInfo: {},
            themeInfo: {
                background_image_url: undefined,
                name: undefined,
                description: undefined,
            },
            klassId: undefined,
            tagId: undefined,
        };
    },
    computed: {
        ...mapGetters(["schoolInfo"]),
		getBgStyle() {
			return function(thumbnail_url) {
				return {
					background: `url(${thumbnail_url}) no-repeat center center`,
					backgroundSize: "cover",
				};
			};
		},
    },

    created() {
        this.initHandle();
    },

    methods: {
        initHandle() {
            this.klassId = this.$route.query.klass_id;
            this.tagId = this.$route.query.id;

            if (this.tagId) {
                this.getThemeInfo();
            } {
                this.getThemeType();
            }
        },

        getThemeType() {
            if (!this.schoolInfo.id) {
                setTimeout(() => {
                    this.getThemeType();
                }, 300);
                return
            }
            ThemeService.getThemeTypeService({ school_id: this.schoolInfo.id }).then(res => {
                this.themeTypeInfo = res[0] || {};
            })
        },
        
        getThemeInfo() {
            this.loading = true;
            ThemeService.getThemeService({ id: this.tagId }).then(res => {
                this.loading = false;
                this.themeInfo = res;
            }).catch(() => {
                this.loading = false;
            })
        },


		viewPhoto(source, index, type = "thumbnail_url") {
			if (!source[index][type] || !source[index][type].startsWith("http") ) return;
			this.imageList = source.filter(item => item[type] && item[type].startsWith("http")).map(item => item[type]);
			this.imageIndex = this.imageList.findIndex((item) => item === source[index][type]);
		},

        customRequest(event) {
            uploadHandle({ file: event.file, klassId: this.klassId }).then(
                (imageObj) => {
                    this.themeInfo.background_image_url = imageObj.thumbnail_url;
                }
            );
        },

        async submitHandle() {
            const { id, name, description, background_image_url } = this.themeInfo;
            if (!name || !name.trim().length) {
                this.$message.warning("主题名称不能为空");
                return;
            }
            if (!description || !description.trim().length) {
                this.$message.warning("主题描述不能为空");
                return;
            }
            if (!background_image_url) {
                this.$message.warning("主题背景不能为空");
                return;
            }

            const params = { name: name.trim(), description: description.trim(), background_image_url };
            this.loading = true;
            if (id) {
                ThemeService.updateThemeService({ id, ...params }).then(() => {
                    this.$message.success("更新成功");
                    this.$router.back();
                }).catch(() => {
                    this.$message.error("更新失败，请检查后重试");
                    this.loading = false;
                });
            } else {
                ThemeService.createThemeService({ ...params, klass_id: this.klassId, type_id: this.themeTypeInfo.id }).then(() => {
                    this.$message.success("新建成功");
                    this.$router.back();
                    this.loading = false;
                }).catch(() => {
                    this.$message.error("新建失败，请检查后重试");
                    this.loading = false;
                });
            }
        },
    },
};
</script>
  
<style lang="less" scoped>
.theme {
    &-container {
        margin-top: 25px;
        margin-right: 100px;
        padding-bottom: 45px;
        background-color: #ffffff;

        /deep/.ant-upload-picture-card-wrapper {
            display: inline-block;
            width: auto;
        }

        /deep/.ant-upload-select-picture-card {
            background-color: #ffffff;
            border: none;
        }

        /deep/.ant-upload {
            margin: 0 !important;
            padding: 0 !important;
        }
    }

    &-content {
        width: 100%;
        display: flex;
        flex-flow: nowrap row;
        padding-left: 50px;
    }

    &-label {
        display: block;
        height: 20px;
        margin: 22px 0 14px;
        font-size: 14px;
        color: #343c6a;
    }

    &-input {
        width: 360px;
        height: 32px;
        border-radius: 4px;
        border-color: #d5d5d5;
    }

    &-logo {
        &_img {
            display: block;
            width: 153px;
            height: 153px;
            margin: 54px 73px 0;
            border-radius: 50%;
            background: #ececee;
            font-size: 40px;
            line-height: 153px;
        }

        &_tips {
            text-align: center;
            color: #cccccc;
        }
    }

    &-background {
        &_image {
            display: block;
            // width: 135px;
            // height: 120px;
            border-radius: 4px;
            background: #ececee;
            font-size: 40px;
            line-height: 120px;
        }
    }

    &-des {
		max-width: 700px;
		width: calc(100% - 30px);
    }
}
</style>
